(function ($) {
	$(document).ready(function () {
		var map = null;

		$('.google-map').each(function () {
			map = new_map($(this));
		});

		changeEvent();
		//printPage();
		eventFormValidation();
		registerOthers();
		editRSVP();
		deleteRSVP();
		//saveMyEvent();

		$('.events-rsvp-submit').click(function (e) {
			e.preventDefault();
			$('.events-rsvp').fadeIn('fast', function () {
				$('.events-rsvp .rsvp-modal-close').focus();
				trapFocus('.events-rsvp');
			});
		});

		$('.rsvp-modal-close').click(function (e) {
			e.preventDefault();
			$('.events-rsvp').fadeOut('fast');
			if ($('.events-rsvp-submit').length > 0) {
				$('.events-rsvp-submit').focus();
			} else {
				$('#main-content').focus();
			}
		});

		$(document).on('keyup', function (e) {
			// Close modal on Escape key
			if (e.key === 'Escape' || e.keyCode === 27) {
				if ($('.events-rsvp-message').length > 0) {
					if ($('.events-rsvp-message').css('display') === 'block') {
						$('.events-rsvp-message-close, .thank-you-rsvp-close').click();
					}
				}
				if ($('.events-rsvp').length > 0) {
					if ($('.events-rsvp').css('display') === 'block') {
						$('.rsvp-modal-close').click();
					}
				}
			}
		});

		$('.events-rsvp-message-close, .thank-you-rsvp-close').click(function (e) {
			e.preventDefault();
			$('.events-rsvp-message').fadeOut('fast');
			if ($('.events-rsvp-submit').length > 0) {
				$('.events-rsvp-submit').focus();
			} else {
				$('#main-content').focus();
			}
		});

		$('.print-tip').tooltipster({
			interactive: true,
			theme: ['tooltipster-shadow', 'tooltipster-shadow-print'],
			distance: 15,
		});
	});

	$(window).load(function () {
		activateFirstEvent();
		showRsvpSubmitted();
		//homeCurrentEvent();
	});

	$(window).resize(function () {
		getWidth();
		//eventResize();
	});

	//functions
	// function homeCurrentEvent(){
	//     var current_event = $('.event-detail').find('.col-lg-8').height();
	//     var width = getWidth();
	//     if(width >= 992) {
	//         $('.events-preview').height(current_event + 100);
	//     }
	// }
	// function saveMyEvent(){
	//     $('.save-event').click(function(e){
	//         e.preventDefault();
	//         var eventid = $(this).data('eventid');
	//         var time = $(this).data('time');

	//         jQuery.ajax({
	//             type: 'POST',
	//             url: '/wp-admin/admin-ajax.php',
	//             data: {
	//                 "action": "save_event",
	//                 save_id: eventid,
	//                 save_time: time
	//             },
	//             success: function(response) {
	//                 $('.save-event').html('Saved');
	//                 $('.save-event').addClass('save-event-saved');
	//             }
	//         });
	//     });
	// }

	function editRSVP() {
		$('#edit-event-rsvp').submit(function (e) {
			e.preventDefault();
			var form_data = $(this).serialize();
			//console.log(form_data);

			$.ajax({
				url: $(this).attr('action'),
				data: $(this).serialize(),
				type: $(this).attr('method'),
				beforeSend: function () {
					$('#edit-event-rsvp').html('<h4>Updating...</h4>');
				},
				success: function (response) {
					console.log(response);
					if (response == 'updated') {
						$('#edit-event-rsvp').hide();
						$('.rsvp-updated').show();
					}
				},
			});
		});
	}

	function deleteRSVP() {
		$('#remove-event-rsvp').click(function (e) {
			e.preventDefault();
			var row_id = $(this).data('row');
			//console.log(row_id);

			$.ajax({
				type: 'POST',
				url: '/wp-admin/admin-ajax.php',
				data: {
					action: 'remove_rsvp',
					id: row_id,
					email: true,
				},
				beforeSend: function () {
					$('.remove-rsvp-area').html('<h4>Removing...</h4>');
				},
				success: function (response) {
					$('#edit-event-rsvp').hide();
					$('.rsvp-updated').hide();
					$('.remove-rsvp-area').hide();
					$('.rsvp-removed').show();
				},
			});
		});
	}

	function getUrlParam() {
		var vars = [],
			hash;
		var hashes = window.location.href
			.slice(window.location.href.indexOf('?') + 1)
			.split('&');
		for (var i = 0; i < hashes.length; i++) {
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}
		return vars;
	}
	function showRsvpSubmitted() {
		var submitted = getUrlParam()['rsvp'];
		//console.log(submitted);
		if (submitted == 'submitted') {
			$('.events-rsvp-message').fadeToggle('fast', function () {
				$('.events-rsvp-message .events-rsvp-message-close').focus();
				trapFocus('.events-rsvp-message .events-rsvp-container');
			});
		}
		if (submitted == 'error') {
			$('.events-rsvp').fadeToggle('fast', function () {
				$('.events-rsvp .rsvp-modal-close').focus();
				trapFocus('.events-rsvp');
			});
			$('.rsvp-error-message').html(
				'There has been a submission error. Please contact CIRSA about the issue.',
			);
		}
	}

	function eventFormValidation() {
		$('#rsvp_submitted').on('click', function () {
			var form = $('#rsvp-form').serialize();
			form.submit();
			$('.events-rsvp-form').html('<h3>Processing your reservation...</h3>');
			dataLayer.push({ event: 'event_rsvp' });
		});

		// $( '#rsvp-form' ).validate({
		//     rules: {
		//         // first_name: {
		//         //     required: true,
		//         //     minlength: 2,
		//         //     maxlength: 50
		//         // },
		//         // last_name: {
		//         //     required: true,
		//         //     minlength: 2,
		//         //     maxlength: 50
		//         // },
		//         // title: {
		//         //     required: true,
		//         //     minlength: 2,
		//         //     maxlength: 50
		//         // },
		//         // entity: {
		//         //     required: true,
		//         //     minlength: 2,
		//         //     maxlength: 50
		//         // },
		//         // phone: {
		//         //     required: true
		//         // },
		//         // email: {
		//         //     required: true,
		//         //     email: true
		//         // }
		//     },
		//     submitHandler: function(form) {
		//         console.log(form);
		//         form.submit();
		//         $('.events-rsvp-form').html('<h3>Processing your reservation...</h3>');
		//         dataLayer.push({'event': 'event_rsvp'});

		//         console.log('form submitted');
		//     }
		// });

		//methods
		$.validator.addMethod(
			'phoneUS',
			function (phone_number, element) {
				phone_number = phone_number.replace(/\s+/g, '');
				return (
					this.optional(element) ||
					(phone_number.length > 9 &&
						phone_number.match(
							/^(\+?1-?)?(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9]))-?[2-9]([02-9]\d|1[02-9])-?\d{4}$/,
						))
				);
			},
			'Please specify a valid phone number (XXX-XXX-XXXX)',
		);

		$.validator.addMethod(
			'addressCheck',
			function (value, element) {
				return (
					this.optional(element) ||
					/\b[A-Za-z]{2}\s+\d{5}(-\d{4})?\b/.test(value)
				);
			},
			'Please specify a valid state and zipcode',
		);
	}

	function activateFirstEvent() {
		var width = getWidth();
		$('.events li:first-child').addClass('active');
		if (width >= 1025) {
			$('#event-1').fadeIn();
		}
	}
	function getWidth() {
		var width = $(window).width();
		return width;
	}

	function eventResize() {
		var width = getWidth();
		if (width >= 768) {
			$('.preview-column .current').css('display', 'none');
		} else {
			$('.events li').addClass('accordion').removeClass('listing');
		}
	}
	function changeEvent() {
		$('.event-content').click(function (e) {
			// console.log('clicked one event');
			var width = getWidth();
			e.preventDefault();

			if ($(this).parents('li').hasClass('active') && width < 998) {
				$(this).parents('li').removeClass('active');
			} else {
				$('.events li').removeClass('active');
				$(this).parents('li').addClass('active');
			}
			var eventID = $(this).find('.event-link').attr('href');
			if (width >= 998) {
				$('.preview-column .event-detail').fadeOut(); //.removeClass('current')
				$(eventID).fadeIn(); //.addClass('current');
			}
			//newHeight(e);
		});
	}

	// function newHeight() {
	//     //e.preventDefault();
	//     //var current_event = $('.event-detail, .current').height();
	//     var events = $('.event-detail').find('.current');
	//     console.log(events);
	//     $.each(events, function(){
	//         var new_height = $(this).find('.col-lg-8').height();
	//         console.log(new_height);
	//     });
	//     // var new_width = getWidth();
	//     // if(new_width >= 992) {
	//     //     $('.events-preview').height(current_event + 100);
	//     // }
	// }

	function new_map($el) {
		var $markers = $el.find('.marker');

		var args = {
			zoom: 16,
			center: new google.maps.LatLng(0, 0),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			styles: [
				{
					featureType: 'landscape',
					stylers: [
						{
							hue: '#FFBB00',
						},
						{
							saturation: 43.400000000000006,
						},
						{
							lightness: 37.599999999999994,
						},
						{
							gamma: 1,
						},
					],
				},
				{
					featureType: 'road.highway',
					stylers: [
						{
							hue: '#FFC200',
						},
						{
							saturation: -61.8,
						},
						{
							lightness: 45.599999999999994,
						},
						{
							gamma: 1,
						},
					],
				},
				{
					featureType: 'road.arterial',
					stylers: [
						{
							hue: '#FF0300',
						},
						{
							saturation: -100,
						},
						{
							lightness: 51.19999999999999,
						},
						{
							gamma: 1,
						},
					],
				},
				{
					featureType: 'road.local',
					stylers: [
						{
							hue: '#FF0300',
						},
						{
							saturation: -100,
						},
						{
							lightness: 52,
						},
						{
							gamma: 1,
						},
					],
				},
				{
					featureType: 'water',
					stylers: [
						{
							hue: '#0078FF',
						},
						{
							saturation: -13.200000000000003,
						},
						{
							lightness: 2.4000000000000057,
						},
						{
							gamma: 1,
						},
					],
				},
				{
					featureType: 'poi',
					stylers: [
						{
							hue: '#00FF6A',
						},
						{
							saturation: -1.0989010989011234,
						},
						{
							lightness: 11.200000000000017,
						},
						{
							gamma: 1,
						},
					],
				},
			],
			//source: https://snazzymaps.com/style/134/light-dream
		};

		var map = new google.maps.Map($el[0], args);

		map.markers = [];

		$markers.each(function () {
			add_marker($(this), map);
		});

		center_map(map);

		return map;
	}

	function add_marker($marker, map) {
		var latlng = new google.maps.LatLng(
			$marker.attr('data-lat'),
			$marker.attr('data-lng'),
		);

		var marker = new google.maps.Marker({
			position: latlng,
			map: map,
			//icon    : '/wp-content/themes/brandjuice/assets/images/pentagon-icon.png'
		});

		map.markers.push(marker);

		if ($marker.html()) {
			var infowindow = new google.maps.InfoWindow({
				content: $marker.html(),
			});
			google.maps.event.addListener(marker, 'click', function () {
				infowindow.open(map, marker);
			});
		}
	}

	function center_map(map) {
		var bounds = new google.maps.LatLngBounds();

		$.each(map.markers, function (i, marker) {
			var latlng = new google.maps.LatLng(
				marker.position.lat(),
				marker.position.lng(),
			);
			bounds.extend(latlng);
		});

		if (map.markers.length == 1) {
			map.setCenter(bounds.getCenter());
			map.setZoom(16);
		} else {
			map.fitBounds(bounds);
		}
	}

	function registerOthers() {
		var count = 0;
		var other_count = $('input[name=other-count]');
		//add other rsvp block
		$('.register-btn').on('click', function (e) {
			e.preventDefault();
			count++;
			other_count.val(count);
			var meals = $('.form-radio-block').clone().first();
			meals.find('input').prop('name', 'meal_other_' + count);

			$('.rsvp-register-others-group').append(
				`<div class="one-registered-group" data-count="${count}"><p>Add An Entity Representative <span class="remove-other-block" data-count="${count}">Remove</span></p><div class="form-field form-field-left"><label class="form-label" for="first_name_other_${count}">First Name:*</label><input type="text" name="first_name_other_${count}" id="rsvp_first_name_other_${count}" /></div><div class="form-field form-field-right"><label class="form-label" for="last_name_other_${count}">Last Name:*</label><input type="text" name="last_name_other_${count}" id="rsvp_last_name_other_${count}" /></div><div class="form-field form-field-left"><label class="form-label" for="title_other_${count}">Title:*</label><input type="text" name="title_other_${count}" id="rsvp_title_other_${count}" /></div><div class="form-field form-field-right"><label class="form-label" for="email_other_${count}">Email Address:*</label><input type="text" name="email_other_${count}" id="rsvp_email_other_${count}" /></div></div>`,
			);

			if (meals) {
				$(
					'.rsvp-register-others-group .one-registered-group[data-count="' +
						count +
						'"]',
				).append(meals);
			}
		});
		//remove other rsvp block
		$('.rsvp-register-others-group').on(
			'click',
			'.remove-other-block',
			function (e) {
				e.preventDefault();
				var num = $(this).data('count');
				$('.one-registered-group').each(function () {
					if ($(this).data('count') == num) {
						$(this).remove();
						count--;
						other_count.val(count);
					}
				});
			},
		);
	}
	$(document).on(
		'click',
		'.events-preview .tribe-events-has-events a',
		function (e) {
			e.preventDefault();
			// $(".event-info-box")

			// const x = e.pageX - e.currentTarget.offsetLeft;
			// const y = e.pageY - e.currentTarget.offsetTop;
			// $('.event-info-box').css('top', x);
			// $('.event-info-box').css('left',y);

			date = $(this).attr('data-day');
			$('.event-info-box').addClass('active');
			// $('.event-info-box .inner').empty();
			$('.day-control').hide();

			function slickCarousel() {
				$('.event-info-box .inner').slick({
					infinite: true,
					arrows: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
					nextArrow: $('.day-control .next-slide'),
					prevArrow: $('.day-control .prev-slide'),
				});
			}
			function destroyCarousel() {
				if ($('.event-info-box .inner').hasClass('slick-initialized')) {
					$('.event-info-box .inner').slick('destroy');
				}
			}

			$.ajax({
				type: 'POST',
				url: '/wp-admin/admin-ajax.php',
				dataType: 'html',
				data: {
					action: 'filter_dates',
					date: date,
				},
				beforeSend: function () {
					destroyCarousel();
					$('.event-info-box .inner').html(
						'<span class="loading">Loading Events...</span>',
					);
				},
				success: function success(res) {
					$('.event-info-box .inner').html(res);
					var numItems = $('.one-day-card').length;
					// console.log(numItems);
					if (numItems < 2) {
						$('.day-control').hide();
					} else {
						$('.day-control').show();
					}

					slickCarousel();
				},
			});
		},
	);
	$('.event-info-box .closeit').on('click', function (e) {
		e.preventDefault();
		$('.event-info-box').removeClass('active');
		$('.tribe-mini-calendar-day-link').removeClass('active-day');
	});

	//blkdg ADA add aria label to calendar forward and back
	// const calendarPrevBtn = document.getElementsByClassName('prev-month');
	// const calendarPrevBtnFirst = calendarPrevBtn[0];
	// calendarPrevBtnFirst.setAttribute("aria-label", "button which switches view to previous month");

	// const calendarNextBtn = document.getElementsByClassName('next-month');
	// const calendarNextBtnFirst = calendarNextBtn[0];
	// calendarNextBtnFirst.setAttribute("aria-label", "button which switches view to next month");

	// Traps focus within the success message modal
	function trapFocus(modalSelector) {
		const modal = document.querySelector(modalSelector);
		if (!modal) return;
		const focusableElements = modal.querySelectorAll(
			'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])',
		);
		const firstFocusable = focusableElements[0];
		const lastFocusable = focusableElements[focusableElements.length - 1];
		modal.addEventListener('keydown', function (e) {
			if (e.key === 'Tab' || e.keyCode === 9) {
				if (e.shiftKey) {
					// Shift + Tab
					if (document.activeElement === firstFocusable) {
						e.preventDefault();
						lastFocusable.focus();
					}
				} else {
					// Tab
					if (document.activeElement === lastFocusable) {
						e.preventDefault();
						firstFocusable.focus();
					}
				}
			}
		});
	}
})(jQuery);
